module.exports = __webpack_public_path__ + "img/DP011C_001.f265132c.png";